import FdTextField from "../UIComponents/TextField/FdTextfield";
import { useForm } from "react-hook-form";
import FdButton from "../UIComponents/Button/FdButton";
import { StoreContext } from "../../store/Store";
import { useContext,  useState } from "react";
import { Box } from "@mui/material";
import { BsXCircleFill } from "react-icons/bs";
import { BiCheckCircle } from "react-icons/bi";

export const SingleTextField = (props: any) => {
  const [state] = useContext(StoreContext);
  const [toggleResp, setToggleResp] = useState({
    resp: "",
    showDetail: false,
  });
  const { setActionDialog } = props;
  const initialValues = {
    textName: "",
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: initialValues,
  });

  const onSubmit = async (value: any) => {
    try {
      if (state.selectedEvent?.singleAttendeeSyncUrl) {
        setActionDialog({
          open: true,
          isLoading: true,
        });
        fetch(state.selectedEvent?.singleAttendeeSyncUrl + value.textName)
          .then((response) => {
            if(response.status === 200) {
                setActionDialog({
                    open: true,
                    maxWidth: false,
                    fullWidth: false,
                    isLoading: false,
                    content: (
                      <Box>
                        <Box>
                          <BiCheckCircle
                            color="green"
                            size={30}
                            style={{ marginBottom: 20 }}
                          />
                        </Box>
                        <Box>Attendee fetched successfully</Box>
                      </Box>
                    ),
                  });
            } else {
                setActionDialog({
                    open: true,
                    content: (
                      <Box>
                        <Box>
                          <BsXCircleFill
                            color="red"
                            size={30}
                            style={{ marginBottom: 20 }}
                          />
                        </Box>
                        <Box>
                          No attendee found
                        </Box>
                      </Box>
                    ),
                    maxWidth: false,
                    fullWidth: false,
                    isLoading: false,
                  });
            }
        })
      }
    } catch (error) {
      setToggleResp((prev) => ({
        ...prev,
        resp: error as any,
        showDetail: true,
      }));
      setActionDialog({
        open: true,
        content: <SingleTextField />,
        maxWidth: false,
        fullWidth: false,
        isLoading: false,
      });
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        {!toggleResp.showDetail ? (
          <>
            <FdTextField
              register={register}
              name="textName"
              label="Third Party Id"
              required
              error={
                errors.textName?.type === "required" ||
                !state.selectedEvent?.singleAttendeeSyncUrl
              }
              errorMsg={
                !state.selectedEvent?.singleAttendeeSyncUrl &&  
                "Please add sync url in event info"
              }
            />
            <FdButton
              variant="contained"
              color="primary"
              ButtonName="Save"
              aria-label="Save-btn"
              type="submit"
              sx={{
                marginTop: "10%",
              }}
            />
          </>
        ) : (
          <Box>
            <Box>
              <BsXCircleFill
                color="red"
                size={30}
                style={{ marginBottom: 20 }}
              />
            </Box>
            {/* @ts-ignore */}
            <Box>{toggleResp.resp}</Box>
          </Box>
        )}
      </form>
    </>
  );
};
